import { render, staticRenderFns } from "./FormAdd.vue?vue&type=template&id=6875af44&scoped=true&"
import script from "./FormAdd.vue?vue&type=script&lang=js&"
export * from "./FormAdd.vue?vue&type=script&lang=js&"
import style0 from "./FormAdd.vue?vue&type=style&index=0&id=6875af44&prod&lang=scss&scoped=true&"
import style1 from "./FormAdd.vue?vue&type=style&index=1&id=6875af44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875af44",
  null
  
)

export default component.exports